export const mergeRefreshedUserIntoAuth = <
  TAuth extends {user: Record<string, any>},
>(
  auth: TAuth,
  refreshedUser: Record<string, any>,
): TAuth =>
  ({
    ...auth,
    user: {
      ...auth.user,
      ...refreshedUser,
      workspace: auth.user.workspace,
    },
  } as TAuth);
